import { render, staticRenderFns } from "./link-demo.vue?vue&type=template&id=f5d2dda8&"
import script from "./link-demo.vue?vue&type=script&lang=js&"
export * from "./link-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports